/**
 * Node customizado para início do fluxo
 * Estilo visual diferenciado com ícone de Play
 * Inclui toolbar flutuante ao selecionar (apenas copiar ID disponível)
 */

import { Handle, Position, NodeProps } from '@xyflow/react';
import { Play } from 'lucide-react';
import { FlowNodeData } from '@/types/flows';
import { FlowNodeToolbar } from './FlowNodeToolbar';

/**
 * Componente visual do node de início
 */
export function StartNode({ data, id, selected }: NodeProps) {
  const nodeData = data as FlowNodeData;
  
  return (
    <div className="bg-primary text-primary-foreground rounded-lg shadow-lg border-2 border-primary min-w-[180px]">
      {/* Toolbar flutuante - apenas copiar ID (start não pode ser editado/excluído) */}
      <FlowNodeToolbar
        nodeId={id}
        nodeType="start"
        isVisible={selected}
      />
      
      <div className="flex items-center gap-2 p-3">
        <div className="bg-primary-foreground/20 p-2 rounded">
          <Play className="h-4 w-4" />
        </div>
        <div className="flex-1">
          <div className="font-semibold text-sm">Início</div>
          <div className="text-xs opacity-90">Gatilho do fluxo</div>
        </div>
      </div>
      
      <Handle
        type="source"
        position={Position.Bottom}
        className="!bg-primary !border-primary-foreground !w-3 !h-3"
      />
    </div>
  );
}
